import Util from '@/lib/util'
export default [
    {
        title:Util.L('Code'),
        key:'id'
    },{
        title:Util.L('Name'),
        key:'name'
    },{
        title:Util.L('PricingTerm'),
        key:'pricingTermName'
    },{
        title:Util.L('CreationTime'),
        key:'creationTime',
        render:(h:any,params:any)=>{
            return h("span", Util.toViewDateString(params.row.creationTime));
        }
    }]